export function displayVehicleIdentifier(identifier, {
  separator = "-"
} = {}) {
  return (identifier === null || identifier === void 0 ? void 0 : identifier.state) && (identifier === null || identifier === void 0 ? void 0 : identifier.license) ? `${identifier.state}${separator}${identifier.license}` : (identifier === null || identifier === void 0 ? void 0 : identifier.vin) ? `VIN${separator}${identifier.vin}` : (identifier === null || identifier === void 0 ? void 0 : identifier.vehicleKey) || "";
}
export function displayOrderVehicleIdentifier(order, opts = {}) {
  return displayVehicleIdentifier({
    state: order.vehicleState,
    license: order.vehicleLicense,
    vin: order.vehicleVin,
    vehicleKey: order.vehicleKey
  }, opts);
}
export const displayVehiclePlate = displayVehicleIdentifier;
export const displayOrderVehiclePlate = displayOrderVehicleIdentifier;
